import React from 'react';
import EffectRegistrationEvaluationTimeOptionsView from './EffectRegistrationEvaluationTimeOptionsView';

const EffectRegistrationEvaluationTimeOptionsPage: React.FC = () => {
  return <EffectRegistrationEvaluationTimeOptionsView />;
};

export default EffectRegistrationEvaluationTimeOptionsPage;
